import { Fragment, useEffect, useState } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { AddModal, EditModal } from "./Modals";
import { addPublication, deletePublication, editPublication, fetchPublications } from "../contexts/fetchPublication";

const publicationStructure = [
    {
        title: "Publication",
        type: "textarea",
        field: "txt",
        init: "",
    },
    {
        title: "Sorting Index",
        type: "text",
        field: "index",
        init: "1",
    },
    {
        title: "Research Fields",
        type: "checkbox",
        field: "fields",
        init: {
            "Theme 1": false,
            "Theme 2": false,
            "Theme 3": false,
            "Theme 4": false,
        },
    },
    {
        title: "Journal",
        type: "text",
        field: "journal",
        init: "",
    },
    
    {
        title: "Link (optional)",
        type: "text",
        field: "url",
        init: "",
    },
]

export const HighlightPublication = props => {

    const { data } = props

    if (data?.journal && data?.txt?.includes(data.journal)) {
        const parts = data.txt.split(data.journal);
        return (
            <span>
                {parts.map((part, index) => (
                    <Fragment key={index}>
                    {part}
                    {index < parts.length - 1 && (
                        <b><i>{data.journal}</i></b>
                    )}
                    </Fragment>
                ))}
                {data?.url ? <span className="ms-2"><a href={data?.url} target="_blank" rel="noopener noreferrer">{"[Link]"}</a> </span> : <></>}
            </span>
        );
    }
    return ( <span>{data?.txt}</span> )
}

const DBPublications = () => {

    const [data, setData] = useState([]);
    const [isShowA, setShowA] = useState(false);
    const [isShowE, setShowE] = useState(false);
    const [eData, setEData] = useState({});

    useEffect(() => {
        fetchPublications(setData);
        return () => {
            setData([]);
            setShowA(false);
            setShowE(false);
            setEData({});
        }
    }, [])

    const handleAddSubmit = async (e, formData) => {
        e.preventDefault();
        try {
            await addPublication(formData);
            await fetchPublications(setData);
            setShowA(false);
        } catch (error) {
            console.error("Error in handleEditSubmit:", error);
            alert("Error adding the publication. Please try again.");
        }
    }

    const handleEditSubmit = async (e, formData) => {
        e.preventDefault();
        try {
            editPublication(formData)
            await fetchPublications(setData);
            setShowE(false);
        } catch (error) {
            console.error("Error in handleEditSubmit:", error);
            alert("Error updating publication. Please try again.");
        }
    };

    const handleDeleteSubmit = async (id) => {
        const confirm = window.confirm("Are you sure you want to delete this publication?");
        if (!confirm) return;
        try {
            await deletePublication(id);
            await fetchPublications(setData);
        } catch (error) {
            console.error("Error deleting publication:", error);
            alert("Error deleting publication. Please try again.");
        }
    };

    return (
        <div>
            <div className="text-end">
                <Button variant="primary" onClick={() => setShowA(true)}>Add</Button>
            </div>
                
            {['Theme 1', 'Theme 2', 'Theme 3', 'Theme 4'].map((theme, tIndex) => (
                <div key={tIndex}>
                    <h5>{theme}</h5>
                    {data?.filter(d => d.fields[theme])?.map((f, i) => (
                        <div key={i}>
                            <span>{"["}{f.index}{"] "}</span>
                            <HighlightPublication data={f} />
                            <br />
                            <ButtonGroup>
                                <Button variant="secondary" onClick={() => {setEData(f); setShowE(true)}}>Edit</Button>
                                <Button variant="danger" onClick={() => handleDeleteSubmit(f.id)}>Delete</Button>
                            </ButtonGroup>
                            <hr />
                        </div>
                    ))}
                </div>

            ))}
            


            <AddModal  isShowM={isShowA} setShowM={setShowA} structure={publicationStructure} onSubmit={handleAddSubmit} /> 
            <EditModal isShowM={isShowE} setShowM={setShowE} structure={publicationStructure} onSubmit={handleEditSubmit} existingData={eData}/> 
        </div>
    )
}

export default DBPublications;